import { render } from "./privateNumber.vue?vue&type=template&id=610d521a&scoped=true"
import script from "./privateNumber.vue?vue&type=script&lang=js"
export * from "./privateNumber.vue?vue&type=script&lang=js"

import "./privateNumber.vue?vue&type=style&index=0&id=610d521a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-610d521a"

export default script